import React from "react"

import styles from "./pricing.module.scss"

const Display = () => {
  return (
    <div className={styles.display}>
      <h2 className={styles.displayText}>Upgrade to full version</h2>
    </div>
  )
}

export default Display
